import { ApiResponse, OfferAcceptBlockCode } from '@letly/models';

export const PROPERTY_LET_AGREED_ERROR_CODE = 'PROPERTY_LET_AGREED';
export const SHORTFALL_NOT_ACKNOWLEDGED: OfferAcceptBlockCode = 'SHORTFALL_NOT_ACKNOWLEDGED';

const REFERENCING_BLOCK_CODES: readonly string[] = [
  'REFERENCING_FAILED',
  'REFERENCING_EXPIRED',
  'REFERENCING_INCOMPLETE',
  'GUARANTOR_REQUIRED',
  'IDENTITY_INCOMPLETE'
] satisfies OfferAcceptBlockCode[];

const letAgreedMessage = () =>
  $localize`:@@offering.error.let-agreed:This home is now let agreed, so it can no longer take offers.`;

const referencingBlockFallback = () =>
  $localize`:@@offering.error.referencing-blocked:This offer can’t be accepted until referencing is complete for every adult.`;

export function offerErrorCode(res: ApiResponse<unknown>): string | undefined {
  return res.error?.error?.code;
}

function backendMessage(res: ApiResponse<unknown>): string | undefined {
  const message: unknown = res.error?.error?.message;
  return typeof message === 'string' && message.trim() ? message : undefined;
}

export function offerErrorMessage(res: ApiResponse<unknown>): string | undefined {
  const code = offerErrorCode(res);
  if (code === PROPERTY_LET_AGREED_ERROR_CODE) {
    return letAgreedMessage();
  }
  if (code && REFERENCING_BLOCK_CODES.includes(code)) {
    return backendMessage(res) ?? referencingBlockFallback();
  }
  return res.niceErrorMessage;
}
